import { Checkbox, FormControlLabel } from "@mui/material";
import { twMerge } from "tailwind-merge";

interface ILegendCheckboxProps {
	checked: boolean;
	onChange: () => void;
	className: string;
	label: string;
}
export const LegendCheckbox = ({ checked, className, onChange, label }: Readonly<ILegendCheckboxProps>) => {
	return (
		<FormControlLabel
			className="!h-[10px] !m-0 !text-default"
			label={label}
			slotProps={{
				typography: {
					className: "!font-sans !text-[14px] select-none",
				},
			}}
			control={
				<Checkbox
					checked={checked}
					onChange={onChange}
					disableRipple
					size="small"
					className={twMerge("!p-0 !pr-[3px] [&_.MuiSvgIcon-root]:w-[14px] [&_.MuiSvgIcon-root]:h-[14px]", className)}
				/>
			}
		/>
	);
};
